import React from 'react';

import type { MenuModel } from '../types';
import AppSubMenu from './AppSubMenu';
import { AUTHORITIES } from 'app/config/constants';

const AppMenu = () => {
  const model: MenuModel[] = [
    {
      label: 'Informácie',
      icon: 'pi pi-info',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.AGENT, AUTHORITIES.ASSISTANT, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'E-mailové novinky',
          icon: 'pi pi-envelope',
          to: '/mail/inbox',
        },
        {
          label: 'Uvítací text',
          icon: 'pi pi-file',
          to: '/document-info',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Top list',
          icon: 'pi pi-star',
          to: '/top-list',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Súťaže',
          icon: 'pi pi-bolt',
          to: '/competitions',
        },
      ],
    },
    {
      label: 'Poradca',
      icon: 'pi pi-users',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'Zoznam',
          icon: 'pi pi-list',
          to: '/agents',
        },
        {
          label: 'Odvod do stornofondu',
          icon: 'pi pi-undo',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/settings/stornofond',
        },
        {
          label: 'Povýšenie',
          icon: 'pi pi-chart-line',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/agents/promotion',
        },
      ],
    },
    {
      label: 'Obchod',
      icon: 'pi pi-briefcase',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.AGENT, AUTHORITIES.ASSISTANT, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'Klienti',
          icon: 'pi pi-users',
          to: '/clients',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Zmluvy',
          icon: 'pi pi-file',
          items: [
            {
              label: 'Sprievodky',
              icon: 'pi pi-file',
              to: '/dispatch-notes',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.SUPER_ADMIN],
            },
            {
              label: 'Nové zmluvy',
              icon: 'pi pi-file',
              to: '/new-contracts',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.SUPER_ADMIN],
            },
            {
              label: 'Zmluvy',
              icon: 'pi pi-file',
              to: '/contracts',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.AGENT, AUTHORITIES.ASSISTANT, AUTHORITIES.SUPER_ADMIN],
            },
          ],
        },
        {
          label: 'Výročia zmlúv',
          to: '/contract-anniversaries',
          icon: 'pi pi-gift',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Upomienky',
          to: '/upomienky',
          icon: 'pi pi-envelope',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'NFA Karty',
          to: '/nfa-cards',
          icon: 'pi pi-credit-card',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.ASSISTANT, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
        },
      ],
    },
    {
      label: 'Provízie',
      icon: 'pi pi-chart-bar',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'Provízie',
          icon: 'pi pi-chart-bar',
          to: '/provisions',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Provízne listy',
          icon: 'pi pi-file',
          to: '/provision-sheets',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.AGENT, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Generovania províznych listov',
          icon: 'pi pi-file',
          to: '/provision-sheet-groups',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Dlžníci',
          icon: 'pi pi-chart-line',
          to: '/reports',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Bonusy a zrážky',
          icon: 'pi pi-money-bill',
          to: '/bonus-deductions',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Čakajúci na provízie',
          icon: 'pi pi-clock',
          to: '/provision-waiting',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Hromadné zmazanie',
          icon: 'pi pi-trash',
          to: '/provision-files',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
        },
      ],
    },
    {
      label: 'Účty',
      icon: 'pi pi-building',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'Platby',
          icon: 'pi pi-wallet',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/payments',
        },
        {
          label: 'Zhodnotenie družstva',
          icon: 'pi pi-heart',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/druzstvo-appreciations',
        },
      ],
    },
    {
      label: 'Na stiahnutie',
      icon: 'pi pi-download',
      to: '/download-document',
    },
    {
      label: 'Nastavenia',
      icon: 'pi pi-cog',
      requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
      items: [
        {
          label: 'Kariéra',
          icon: 'pi pi-chart-line',
          items: [
            {
              label: 'Nová kariéra',
              to: '/careers/2',
            },
            {
              label: 'Stará kariéra',
              to: '/careers/1',
            },
          ],
        },
        {
          label: 'Produkty',
          icon: 'pi pi-box',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/products',
        },
        {
          label: 'Spoločnosti',
          icon: 'pi pi-building',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/settings/insurance-company',
        },
        {
          label: 'Konfigurácia',
          icon: 'pi pi-cog',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          to: '/configurations',
        },
        {
          label: 'Klientské nastavenia',
          requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
          icon: 'pi pi-id-card',
          items: [
            {
              label: 'Klientské novinky',
              icon: 'pi pi-news',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
              to: '/client-news',
            },
            {
              label: 'Žiadosti od klientov',
              icon: 'pi pi-news',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
              to: '/client-requests',
            },
            {
              label: 'Správy od klientov',
              icon: 'pi pi-news',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
              to: '/client-messages',
            },
            {
              label: 'Podmienky používania',
              icon: 'pi pi-news',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
              to: '/create-configuration/client_conditions',
            },
            {
              label: 'Spracovanie osobných údajov',
              icon: 'pi pi-news',
              requiredAuthorities: [AUTHORITIES.ADMIN, AUTHORITIES.SUPER_ADMIN],
              to: '/create-configuration/client_personal_data',
            },
          ],
        },
        {
          label: 'Asistenti',
          icon: 'pi pi-user',
          to: '/assistants',
        },
        {
          label: 'Administrátori',
          icon: 'pi pi-user',
          to: '/admins',
          requiredAuthorities: [AUTHORITIES.SUPER_ADMIN],
        },
        {
          label: 'Iniciálny import',
          icon: 'pi pi-upload',
          to: '/configuration/import/initial-import',
        },
      ],
    },
  ];

  return <AppSubMenu model={model} />;
};

export default AppMenu;
